import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import { Personorg } from '../model/personorg';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Projectperson } from '@src/app/models/projectperson';


@Injectable({
  providedIn: 'root'
})
export class PlanningService {

  constructor(private http:HttpClient) { }

  getList(organizationId:String){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    return this.http.get<Personorg[]>(environment.apiUrl+'/organization/' + organizationId + '/members', httpOptions);
  }

  getPersonProjects( personId:String){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    ///organization/{organizationId}/projectperson/list/person/{personId}		
    return this.http.get<Projectperson[]>(environment.apiUrl+'/organization/' + SessionHelper.getChoosenOrg() + '/projectperson/list/person/'+personId, httpOptions);
  }
}
